export default "__VITE_ASSET__21d7f446__"